<template>
  <div class="container">
    <div class="jr-h5-details" v-if="news.id">
      <!-- <div class="news-title">{{news.title}}</div> -->
      <p v-html="news.content" class="news-content" ref="jrDetailContent"></p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
import jrwxcode from '@/assets/jinrong/wxcode.jpg';
import jrcode from '@/assets/jinrong/code.png';
import wxcode from '@/assets/wxcode.jpg';
import code from '@/assets/code.jpg';
import iztcode from '@/assets/iztcode.jpg';
import mlwxcode from '@/assets/mianliao/wxcode.jpg';
import mlcode from '@/assets/mianliao/code.png';
// import openappview from '../../components/openAppView'
import api from '@/common/http/testapi'

export default {
  components:{
    // openappview
  },
  data () {
    return {
      news: {
      },
      linked: 'http://izt.eastfair.cn/sharepage/index.html#/download',
      isWeixin: true,
      theme: '',
      config: {
        name: 'i展通',
        PCUrl: 'https://jdpharmexpo.com'
      },
      configList: {
        jinrong: {
          name: '金融展',
          PCUrl: 'https://zggjjr.klef.cn',
          code: jrcode,
          wxcode: jrwxcode
        },
        izt: {
          name: 'i展通',
          PCUrl: 'https://jdpharmexpo.com',
          code: code,
          wxcode: wxcode
        },
        mianliao: {
          name: '面料',
          PCUrl: '',
          code: mlcode,
          wxcode: mlwxcode
        },
        silk: {
          name: '丝博会',
          PCUrl: '',
          code: mlcode,
          wxcode: '' 
        }
      }
    }

  },
  created () {
    // this.typeApp=this.$route.query.appName;
    this.theme = this.$route.query.theme;
    const token = this.$route.query.Token || this.$route.query.token
    if (token) {
      this.$store.commit('changeToken', token)
    }

    this.getData();
    if (this.theme == 'jinrongzhan' || this.theme == 'jinrong') {
      // 金融展
      this.config = this.configList['jinrong'];
      return;
    }
    if (this.theme == 'mianliao') {
      // 面料展
      this.config = this.configList['mianliao'];
      return;
    }
    if (this.theme == 'silk') {
      // 丝博会
      this.config = this.configList['silk'];
      return;
    }
    this.config = this.configList['izt'];
    // console.log(this.$util.isWeiXin);

    // this.isWeixin = this.$util.isWeiXin;
  },
  mounted() {
    // this.linked += "?" + window.location.hash.replace('#/newsDetails?', '')
    // this.$nextTick(() => {
    //   document.querySelector("#downLoad").click()
    //   console.log(this.linked)
    // })
  },
  methods: {
    visitWebsite () {
      window.location.href = this.config.PCUrl;
      //  "https://jdpharmexpo.com"
    },
    getData () {
      var exhibitionId = this.$route.query.exhibitionId;
      let languageType = this.$route.query.languageType;
      let appId = this.$route.query.appId;
      let id = this.$route.query.id;
      var params = {
        exhibitionId: exhibitionId,
        languageType: languageType,
        appId: appId,
        id: id,
        sourceType: '',
        terminal: "",
      }
      this.$http.jrH5Details(params).then(res => {
        var data = res.data;
        this.news = data;
        document.title = this.news.title

        // 金融展 新闻详情微信分享
        if (['jinrong', 'jinrongzhan'].includes(this.theme)) {
          if (this.isWeiXinFn()) {
            this.getConfig()
          }
        }
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    getConfig() {
      const url = window.location.href.split('#')[0]
      const params = {
        client_oauth_token: 'EastfairCreditApplication',
        appId: 'wxfedbcc05541526fb',
        url: url
      }

      api.weChatConfigParams(params).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: [
            'updateTimelineShareData', // 分享朋友圈接口
            'updateAppMessageShareData' // 分享给朋友接口
          ]
        });

        wx.ready(() => {
          const contentDom = this.$refs.jrDetailContent
          const desc = contentDom.textContent
          const shareConfig = {
            title: this.news.title,
            desc: desc,
            link: window.location.href,
            imgUrl: this.news.shareImage || this.news.coverIcon,
            success: function(res) {
              console.log(res)
            },
            fail: function(res) {
              console.log(res)
            }
          }
          wx.updateAppMessageShareData(shareConfig);
          wx.updateTimelineShareData(shareConfig);
        })
      })
    },
    isWeiXinFn() {
      const ua = navigator.userAgent.toLowerCase()
      const isWXWork = ua.match(/wxwork/i) == 'wxwork'
      const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
      return isWeixin
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  flex: 1;
  overflow-y: scroll;
  ::v-deep .video-js {
    width: 100%;
    height: auto;
  }
}
img {
  width: 100%;
  height: auto;
}
.jr-h5-details {
  width: 100%;
  box-sizing: border-box;
  // padding: 30px 16px;
  .news-content {
    width: 100%;
    max-width: 100%;
  }
  .news-title {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
  }
}
.QR-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(51, 133, 255, 0.05);
  flex: 1;
  padding: 20px;
}
.code-img {
  width: 126px;
  height: 126px;
}
.code-item-content {
  margin-top: 6px;
  color: #424242;
  font-size: 13px;
  text-align: center;
}
.item-content {
  font-weight: bold;
}
.visit-website {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(71, 145, 255, 1);
  margin: 20px 0;
}
.website-button {
  border-radius: 2px;
  border: 1px solid rgba(71, 145, 255, 1);
  padding: 6px 16px;
}
.visit-count {
  text-align: right;
  font-size: 10px;
  color: rgba(145, 145, 145, 1);
  box-sizing: border-box;
}
</style>